/**
 * Copy for the "Validering af kursusbevis" info dialog.
 *
 * Two things about the card the text has to get right, because both surprise
 * members:
 *
 * 1. Not every row is assessed. `validate_kursusbevis` in cle-compliance-api
 *    scores eight fields, but `courseTitle` is not one of them — the card renders
 *    it for information, so it carries no ✓/✗. Saying "alle felter skal være
 *    godkendt" would therefore describe a row that can never be either.
 * 2. A row can appear that isn't in the normal list. `courseTime`
 *    ("Kursets varighed") is validated by the API but has no hardcoded row, so
 *    `appendUnmatchedFailingFields` appends it when it fails.
 */
const CourseCertificateValidationInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <p className="mb-0">
        Valideringen viser de oplysninger, der er læst på kursusbeviset. De
        felter, der indgår i vurderingen, får et flueben, hvis de opfylder
        kravene, og et kryds, hvis de ikke gør. Under et felt med kryds står
        der, hvad der mangler eller ikke passer.
      </p>
      <p className="mb-0">
        Kursusbeviset bliver kun godkendt, når alle vurderede felter er
        godkendt. Kursustitlen vises til orientering og indgår ikke i
        vurderingen. Et felt, der ikke kunne læses på beviset, står som “Ikke
        angivet”.
      </p>
      <p className="mb-0">
        Ser du et felt, der ikke står i listen ovenfor — for eksempel “Kursets
        varighed” — er det et krav, beviset er faldet på.
      </p>
      <p className="mb-0">
        Valideringen udføres af AI og kan lave fejl. Mener du, at vurderingen er
        forkert, kan du skrive til sekretariatet i kortet “Besked til
        sekretariatet”.
        {/* TODO(sekretariatet): må medlemmet uploade et rettet kursusbevis i
            stedet, eller skal sekretariatet rette vurderingen? Det er det
            første, en afvist bruger vil vide. */}
      </p>
    </div>
  );
};

export default CourseCertificateValidationInfoContent;
